import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAnexoUser, getConsentimiento, getDDJJUser } from '../../actions/index'
import 'reactjs-popup/dist/index.css';
import { PDFViewer } from '@react-pdf/renderer';
import AnexoPDF from '../ReactPDF/AnexoPDF'

const AdminANEXO = () => {

  const token = localStorage.getItem('token')

  const ddjj = useSelector(state => state.ddjj)
  const anexoDoc = useSelector(state => state.anexoUser)
  const consentimiento = useSelector(state => state.consentimiento)
  
  const dispatch = useDispatch()
  
  useEffect(()=>{ 
    dispatch(getAnexoUser(token))
    dispatch(getDDJJUser(token))
    dispatch(getConsentimiento(token))
  }, [])

  return (
    <div>
      { ddjj.length>0 && anexoDoc && consentimiento?
        <PDFViewer style={{ width: '100%', height: '100vh'}}>
        <AnexoPDF props={[anexoDoc,consentimiento]} ddjj={ddjj} />
      </PDFViewer>:<div>Loading...</div>}
    </div>
  )
}

export default AdminANEXO